import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = 'HomePage';

  constructor(platform: Platform) {
    platform.ready().then(() => {
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts